/**
 * Quiz/Scale 3182:15070 — continuous 0–100 rating shown as five named steps.
 * Thumb centres run from 20px to (width − 20px); step dots sit at 0/25/50/75/100.
 */
export const FAIR_QUIZ_SCALE_STEPS = [1, 2, 3, 4, 5] as const
export type FairQuizScaleStep = (typeof FAIR_QUIZ_SCALE_STEPS)[number]

export const FAIR_QUIZ_SCALE_INSET = 20
export const FAIR_QUIZ_SCALE_KEY_STEP = 5
export const FAIR_QUIZ_SCALE_KEY_PAGE = 25

export function clampFairQuizScale(value: number): number {
  return Math.round(Math.max(0, Math.min(100, value)))
}

/** Nearest of the five named steps (0 → 1 … 100 → 5). */
export function fairQuizScaleStep(value: number): FairQuizScaleStep {
  return (Math.round(clampFairQuizScale(value) / 25) + 1) as FairQuizScaleStep
}

/** Pointer x inside the track (px) → value. */
export function fairQuizScaleValueAt(x: number, width: number): number {
  const span = width - FAIR_QUIZ_SCALE_INSET * 2
  if (span <= 0) return 50
  return clampFairQuizScale(((x - FAIR_QUIZ_SCALE_INSET) / span) * 100)
}

/** Keyboard: arrows ±5, PageUp/Down ±25, Home/End 0/100. `null` — not a scale key. */
export function fairQuizScaleKeyValue(key: string, value: number): number | null {
  switch (key) {
    case 'ArrowRight':
    case 'ArrowUp':
      return clampFairQuizScale(value + FAIR_QUIZ_SCALE_KEY_STEP)
    case 'ArrowLeft':
    case 'ArrowDown':
      return clampFairQuizScale(value - FAIR_QUIZ_SCALE_KEY_STEP)
    case 'PageUp':
      return clampFairQuizScale(value + FAIR_QUIZ_SCALE_KEY_PAGE)
    case 'PageDown':
      return clampFairQuizScale(value - FAIR_QUIZ_SCALE_KEY_PAGE)
    case 'Home':
      return 0
    case 'End':
      return 100
    default:
      return null
  }
}
